<template>

  <div class="out"
    id="out"
    v-on:scroll.passive="handleScroll">

    <div class="div-main flex-col"
      :class="{'pad-top':isFixed}">
      <div id="title-fixed"
        v-if="isFixed"
        class="title-fixed">
        <span v-if="isFixed"
          class="iconfont iconarrowleft-fill icon-back-fixed"
          :style="{'opacity': opacity}"
          @click="back"></span>
        <span :style="{'opacity': opacity}"
          class="fix-content"
          style="line-height:42px;">
          {{data.name }}
        </span>
      </div>
      <div class="top"
        v-if="!isFixed">
        <img class="img-back"
          src="/src/assets/imgs/back.png"
          alt=""
          @click="back" />
      </div>
      <div class="org-info"
        id="org-info">
        <div class="title"
          id="title">
          <span class="name"
            v-text="data.name"> </span>
          <span v-if="!isMarked"
            class="mark not-marked add-button"
            @click="mark">
            + 收藏
          </span>
          <span v-if="isMarked"
            class="mark marked add-button"
            @click="mark"> 已收藏 </span>
          <span class="add-relation"
            @click="goToAddRelationshipPage">+ 关系</span>
        </div>
        <div class="rel-org">
          <div class="rel-names">
            <span> 当前轮次</span>
            {{  getCurrentRound() }}
          </div>

          <div class="rel-names">
            <span> 所在地</span>
            {{ ellipsis(data.city,8)}}
          </div>

          <div class="date">
            成立时间 <span v-text="showDate"></span>
          </div>
        </div>
        <div class="tags">
          <van-tag v-for="ins in industryFieldArr"
            :key="ins"
            plain
            type="primary"
            class="my-tag">
            {{ ins }}
          </van-tag>
        </div>

        <div class="cont-intro"
          v-text="data.introduction"></div>
      </div>
      <div class="content"
        ref="container">

        <van-tabs v-model="active"
          style="height: 100%"
          sticky
          offset-top="64px">
          <van-tab title="融资历程">
            <invested-his :data-list="data.fundingList"></invested-his>
          </van-tab>
          <van-tab title="公司团队">
            <member-list :org-id="orgId" :member-list="data.memberList"
              member-type="company"></member-list>
          </van-tab>
          <van-tab title="股东信息">
            <gongshang :data-list="gongshangInvestors"></gongshang>
          </van-tab>
          <van-tab title="相关资讯">
            <related-news :data-type="dataType"
              :related-id="data.apiID"></related-news>

          </van-tab>
        </van-tabs>

      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import webService from "@network/webService";
import scollerLocation from '@/common/scollerLocation';
import InvestedHis from "@components/content/invested/InvestedHis";
import MemberList from "@components/content/invested/MemberList";
import Gongshang from "@components/content/invested/Gongshang";
import RelatedNews from "@components/content/invested/RelatedNews";

export default {
  data () {
    return {
      ofTop: 0,
      titleHeight: 0,
      isFixed: false,
      opacity: 1,
      //
      active: 0,
      isMarked: false,
      buttonDisabled: false,
      dataType: common.relationshipSearchTypeEnum.Invested,
      data: {
        fundingList: [],
      },
      gongshangInvestors: [],
      orgId:'',
    };
  },
  components: {
    InvestedHis,
    MemberList,
    Gongshang,
    RelatedNews,
  },
  computed: {
    showDate () {
      if (this.data.investDate) {
        return this.$moment(this.data.createTime).format("yyyy-MM-DD");
        // return this.data.investDate.replace('T', ' ');
      }
      return "";
    },
    industryFieldArr () {
      if (this.data.industryField) {
        return _.split(this.data.industryField, ",", 10);
      } else {
        return [];
      }
    },
  },
  
    activated() {
        this.isFixed = false;
        scollerLocation.recoverLocation("out");
    },
    beforeRouteLeave(to, from, next) {
        var orgMemberList = document.querySelector("#out");
        if (orgMemberList) {
            scollerLocation.saveLocation("out", orgMemberList);
        }
        next();
    },
  mounted () {
      this.orgId=this.$route.query.id;

      this.$bus.$on("busfreshComp", ({orgId}) => {
            this.init(orgId);
        });

    var testid = this.$route.query.id; //"0d10a773-5bb7-452e-a049-30e0abe64d50";
    //this.$route.query.id)
    this.init(testid);
    common.addViewHistory(
      this.$route.query.id,
      common.favoriteTypeEnum.InvestedCompany
    );
  },
  methods: {
      init(testid){
            webService.getInvestedDetail(testid).then((res) => {
                console.log(res);
                this.data = res.data;
                if (this.data.gongshangInvestors) {
                    this.gongshangInvestors = JSON.parse(
                    this.data.gongshangInvestors
                    );
                }
                this.isMarked = res.data.marked;
                });
      },
    handleScroll () {
      let scrollTop = document.getElementById("out").scrollTop;
      let orginfo = document.getElementById("org-info");
      if (orginfo) {
        this.ofTop = orginfo.offsetTop;
        // console.log("this.ofTop: " + this.ofTop);
      }
      let mainH =
        document.getElementsByClassName("div-main")[0].offsetHeight;
      let viewH = document.body.offsetHeight;
      let diff = mainH - viewH;
      // console.log(scrollTop, diff);
      if (scrollTop >= diff && this.active == 1) {
        console.log("哈哈哈，我是有底线的。。。");
      }
      //获取标题元素高度
      let title = document.getElementById("title");
      // debugger;
      if (title) {
        this.titleHeight = title.offsetHeight;
      }

      //获取标题距离页面偏移高度
      // console.log("scrollTop:" + scrollTop);
      // console.log("ofTop:" + this.ofTop);
      console.log("scrollTop:" + scrollTop, "ofTop: " + this.ofTop);
      //去掉固定top 的高度，用于滚动实际计算
      let calcH = this.ofTop;
      let opc = 0;
      //滚动高度大于实际计算的偏移高度之后，需要开始显示固定bar
      if (scrollTop >= calcH) {
        //继续滚动的时候，计算超出实际计算的高度，并计算占有实际 title 高度的百分比
        opc = ((scrollTop - calcH) * 1.0) / this.titleHeight;
        // opc = 1;
        this.opacity = opc;
        console.log("opc", opc);
      }
      //百分比小于0之后，表明需要隐藏 固定bar
      if (opc <= 0) {
        this.isFixed = false;
      } else {
        //有透明度，表示需要显示 固定bar
        this.isFixed = true;
      }
    },
    getCurrentRound () {
      var list = _.reverse(
        _.sortBy(this.data.fundingList, function (item) {
          return item.fundingDate;
        })
      );
      if (list.length > 0) {
        return list[0].round;
      }
    },
    ellipsis (val) {
      return common.ellipsis(val, 8);
    },
    back () {
      this.$router.go(-1);
    },
    mark () {
      // debugger;
      // this.marked = !this.marked;
      //   this.$set(this.data, "marked", !this.data.marked);
      //   console.log(this.data);
      common.mark(
        this,
        this.$route.query.id,
        common.favoriteTypeEnum.InvestedCompany,
        this.isMarked
      );
    },
    goToAddRelationshipPage () {
      let companyData = {
        apiID: this.data.apiID,
        id: this.data.id,
        index: 1,
        name: this.data.name,
      };
      this.$router.push({
        path: "/home/addRelationship",
        query: {
          companyData: companyData,
          type: "company",
        },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.out {
  height: 100%;
  overflow: auto;
}
.div-main {
  // height: 100%;
}
.top {
  padding: 10px 18px;
  //padding-left: 1.125rem;
  background-color: #d04a02;
  height: 35px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  .img-back {
    width: 2.5rem;
    height: 2.5rem;
  }
}
.add-relation {
  position: absolute;
  width: 45px;
  height: 30px;
  line-height: 30px;
  right: 65px;
  bottom: 0;
  padding: 0 0.375rem;
  text-align: center;
  color: white;
  background-color: #d04a02;
  font-size: 14px;
}
.add-button {
  font-size: 14px;
  right: -5px;
  width: 45px;
}
.org-info {
  padding: 1.125rem;
  border-bottom: 6px solid #f2f2f2; // height: 8.5rem;
  flex-shrink: 0;
  .org-logo {
    // height: 2.5rem;
    // position: relative;
    // .img-avater {
    //     position: absolute;
    //     top: -2.5rem;
    //     width: 4.375rem;
    //     height: 4.375rem;
    // }
    .img-logo {
      position: absolute;
      top: -2.5rem;
      height: 4.375rem;
      width: 4.375rem;
    }
  }
  .title {
    // margin-top: 0.75rem;
    position: relative;

    .name {
      font-size: 1.625rem;
      font-weight: bolder;
      color: #363636;
      display: flex;
      max-width: 60%;
    }
  }
  .rel-org {
    padding: 0.5rem 0;
    font-size: 0.75rem;
    color: #eb8c00;
    .rel-names {
      display: inline-block;
      //   width: 170px;
      margin-right: 14px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    .date {
      display: inline-block;
      font-size: 0.75rem;
      color: rgb(131, 131, 131);

      overflow: hidden;
    }
  }
  .tags {
    padding: 0.375rem 0.0625rem;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;

    .my-tag {
      background-color: #f7f7f7;
      font-size: 0.75rem;
      color: rgb(131, 131, 131);
      padding: 4px;
      margin-right: 10px;
    }
    .my-tag::before {
      border: none;
    }
  }
  .cont-intro {
    font-size: 14px;
    line-height: 22px;
    color: #464646;
  }
}
.content {
  flex: 1;
  // height: 100%;
  overflow: hidden;
  // position: relative; //   height: calc(100%-1.25rem);

  font-size: 1rem;
  color: #7d7d7d;
  line-height: 1.5rem;
}
/deep/ .van-tabs__wrap {
  border-bottom: 1px solid #dedede;
}
/deep/ .van-tabs__content {
  height: calc(100% - 45px);
  overflow: auto;
}
/deep/ .van-tabs {
  height: 100%;
}

.title-fixed {
  position: absolute;
  top: 0;
  color: #fff;
  background-color: #d04a02;
  font-size: 16px;
  margin: 0 auto;
  width: calc(100% - 10px); // padding: 10px 0px 0px 50px;
  padding-top: 10px;
  padding-left: 10px;
  height: 54px;

  z-index: 999999;

  .fix-content {
    margin-left: 30px;
  }
}
.pad-top {
  padding-top: 96px;
}
.tab-fixed {
  // height: 100%;
  position: fixed;
  top: 64px;
  background-color: #fff;
}
.icon-back-fixed {
  // display: inline-block;
  position: absolute;
  // left: 14px;
  top: 18px;
  color: #fff;
  z-index: 999;
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/content/invested/InvestedDetail.vue